/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component() {
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page no-navbar no-toolbar no-swipeback">
      <div class="page-content login-screen-content display-flex flex-direction-column justify-content-center" style="background-image: url('./static/images/back_1.jpg');background-position: center bottom; background-repeat: no-repeat;">
        <div class="login-screen-title">Usados</div>
        <form>
          <div class="list">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Usuario</div>
                  <div class="item-input-wrap">
                    <input type="text" name="username" placeholder="Usuario" />
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Contraseña</div>
                  <div class="item-input-wrap">
                    <input type="password" name="password" placeholder="Contraseña" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="list">
            <ul>
              <li><a href="#" class="list-button">Ingresar</a></li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  `
    }
    ;
}

framework7Component.id = 'a6ca59b492';
export default framework7Component;